import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogActions, MatDialogClose, MatDialogTitle, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ScnackbarData, ToastService, SnackbarStyles } from '../toast.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UnidadOrganizacionalService } from '../../services/unidad-organizacional.service';
import { UnidadOrganizacional } from '../../models/UnidadOrganizacional';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { PlantillasMemosService } from '../../services/plantillas-memos.service';
import { PlantillaMemo } from '../../models/PlantillaMemo';

@Component({
    selector: 'app-dlg-add-plantilla-memo',
    imports: [
        MatButtonModule, MatDialogActions, MatDialogClose, MatDialogTitle, MatDialogContent,
        ReactiveFormsModule,
        MatFormFieldModule, MatInputModule,
        MatProgressSpinnerModule,
        MatSelectModule, MatOptionModule
    ],
    templateUrl: './dlg-add-plantilla-memo.component.html',
    styleUrl: './dlg-add-plantilla-memo.component.scss'
})
export class DlgAddPlantillaMemoComponent {
  readonly dialogRef = inject(MatDialogRef<DlgAddPlantillaMemoComponent>)

  fetchingAddTemplateMemo = false
  snackbarData: ScnackbarData = {}

  addTemplateMemo = new FormGroup({
    codigoDepartamento: new FormControl("", {
      validators: [Validators.required]
    }),
    nombrePlantilla: new FormControl("", {
      validators: [Validators.required]
    }),
    descripcion: new FormControl("", {
      validators: [Validators.required]
    }),
    definicionCampo: new FormControl("", {
      validators: [Validators.required]
    }),
  })

  departamentos: UnidadOrganizacional[] = []

  constructor(
    private toast: ToastService,
    unidadOrganizacionalService: UnidadOrganizacionalService,
    private plantillasMemosService: PlantillasMemosService
  ) {
    unidadOrganizacionalService.listDepartamentos().subscribe({
      next: (response) => {
        this.departamentos = response
      }
    })
  }

  addTemplateMemoHandler() {
    const controls = this.addTemplateMemo.controls
    const plantillaMemo: PlantillaMemo = {
      codigoDpto: controls.codigoDepartamento.getRawValue()!,
      nomPlantilla: controls.nombrePlantilla.getRawValue()!,
      descripcion: controls.descripcion.getRawValue()!,
      definicCampo: controls.definicionCampo.getRawValue()!,
    }
    this.plantillasMemosService.create(plantillaMemo).subscribe({
      next: (response) => {
        this.snackbarData.message = "Plantilla memo agregada"
        this.snackbarData.style = SnackbarStyles.Success
        this.snackbarData.iconName = "check_circle"
        this.toast.show(this.snackbarData)
        this.fetchingAddTemplateMemo = false
        this.dialogRef.close(response)
      },
      error: () => {
        this.snackbarData.message = "Error agregando plantilla memo"
        this.snackbarData.style = SnackbarStyles.Error
        this.snackbarData.iconName = "error"
        this.toast.show(this.snackbarData)
        this.fetchingAddTemplateMemo = false
        this.dialogRef.close(null)
      }
    })
  }

}
